module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("iKsFR"))).then(() => parcelRequire('5erN3'));